import Button from "@material-ui/core/Button";
import React, {useMemo, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "./AppBar";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {Trans, useTranslation} from "react-i18next";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import {Container} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import {formatCurrency} from "../../../../../utils";
import {useHistory} from "react-router";
import {callAPI} from "../../../../../lib/common";
import {useShoppingCart} from "../../../hooks/shoppingcart";
import LoadingButton from "../../../../Common/LoadingButton";

const useStyles = makeStyles(theme => ({
    mainContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        '& h2': {
            textAlign: 'center'
        }
    },
    buttonContainer: {
        padding: theme.spacing(2),
        textAlign: 'center'
    },
    subProductList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        '& > li': {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            borderBottom: '1px solid #BFBFBF',
        }
    },
    iconButton: {
        width: '40px',
        height: '40px',
        border: 'none',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.getContrastText(theme.palette.primary.main),
        flexShrink: 0
    },
    quantity: {
        boxSizing: 'border-box',
        width: '40px',
        height: '40px',
        textAlign: 'center',
        fontSize: '18px',
        fontWeight: 'bold',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    productRow: {
        display: 'flex',
        alignItems: 'center'
    },
    productName: {
        marginLeft: theme.spacing(1),
        fontSize: '15px'
    },
    totalSummary: {
        fontSize: '18px',
        fontWeight: 'bold',
        display: 'flex',
        borderBottom: '1px solid #BFBFBF',
        paddingBottom: '3px',
        '& > *': {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            borderBottom: '1px solid #BFBFBF',
        }
    },
    totalQuantityContainer: {
        width: 40 + 40 + 40 + theme.spacing(1) + theme.spacing(1),
        textAlign: 'center',
    },
    totalPriceContainer: {
        paddingLeft: theme.spacing(1),
        flexGrow: 1
    },
    productPriceContainer: {
        display: 'flex',
        fontSize: '12px'
    },
    productPrice: {
    },
    oldPrice: {
        textDecoration: 'line-through',
        marginLeft: theme.spacing(2)
    }
}))

export default ({changeMenu}) => {
    const classes = useStyles();
    const [state] = useTemplateInstance();
    const product = state.product;
    const { productHasCampaign, getPricePerUnit, calculateLinePrice } = usePriceList();
    const [quantity, setQuantity] = useState(() => {
        const quantity = {};
        if (product.subproducts.length == 0) {
            quantity[""] = product.minorderpartquantity;
        }
        return quantity
    });
    const history = useHistory();
    const {updateCart} = useShoppingCart();
    const [t] = useTranslation();
    const [isUpdating, setIsUpdating] = useState(false);

    const hasCampaignPrice = useMemo( () => {
        for (const category of state.template.categories) {
            if (productHasCampaign(product, category)) {
                return true;
            }
        }
        return false;
    }, [product, state]);

    const increaseQuantity = (uuid) => {
        return () => {
            setQuantity( quantity => {
                let num = quantity[uuid] || 0;

                if (num < product.minorderpartquantity) {
                    num = product.minorderpartquantity;
                }
                else {
                    num++;
                }

                return {
                    ...quantity,
                    [uuid]: num
                }
            })

        }
    }

    const decreaseQuantity = (uuid) => {
        return () => {
            setQuantity( quantity => {
                let num = quantity[uuid] || 0;
                num--;
                if (num < product.minorderpartquantity) {
                    num = 0;
                }

                return {
                    ...quantity,
                    [uuid]: num
                }
            })

        }
    }

    const handleChange = (uuid) => {
        return (e) => {
            const num = e.target.value;
            setQuantity( quantity => {
                return {
                    ...quantity,
                    [uuid]: num
                }
            });
        }
    }

    const handleBlur = (uuid) => {
        return (e) => {
            let num = parseInt(e.target.value);
            setQuantity( quantity => {
                if (!Number.isInteger(num)) {
                    num = 0;
                }
                else if (num < product.minorderpartquantity) {
                    num = 0;
                }
                return {
                    ...quantity,
                    [uuid]: num
                }
            });
        }
    }

    const calculateSubProductPrice = (product, subproduct, quantity, hasCampaignPrice) => {
        if (!quantity) {
            quantity = 1;
        }
        return (getPricePerUnit(product, quantity, hasCampaignPrice) + subproduct.extraprice);
    }

    const totalQuantity = useMemo(() => {
        console.log('Total quantity', quantity);
        return Object.keys(quantity).reduce((qty, subproductUuid) => {
            if (quantity[subproductUuid] && !isNaN(quantity[subproductUuid])) {
                qty += quantity[subproductUuid];
            }
            return qty;
        }, 0);
    }, [quantity])

    const totalPrice = useMemo( () => {
        return Object.keys(quantity).reduce((totalPrice, subproductUuid) => {
            if (quantity[subproductUuid] && !isNaN(quantity[subproductUuid])) {
                totalPrice += calculateLinePrice(product.uuid, quantity[subproductUuid], subproductUuid, hasCampaignPrice);
            }
            return totalPrice;
        }, 0);
    }, [quantity]);


    const handleAddToCart = async () => {
        const resources = Object.values(state.resources).filter(resource => resource.userSupplied);
        const templateUuid = state.template.uuid;
        const products = Object.keys(quantity).reduce((products, uuid) => {
            const qty = quantity[uuid];
            let subproducts = [];
            if (uuid) {
                subproducts = [uuid];
            }
            if (qty >= product.minorderpartquantity) {
                products.push({
                    product: product.uuid,
                    subProductUuids: subproducts,
                    quantity: quantity[uuid],
                    template: {
                        uuid: templateUuid,
                        resources: resources,
                        year: state.year,
                    }
                })
            }
            return products;
        }, []);

        setIsUpdating(true);
        for (const p of products) {
            await callAPI('/m/api/webshop/cart', 'POST', p);
        }

        await updateCart();
        console.log('Products', products);

        history.push('/cart')
    }

    const cartIsEnabled = useMemo(() => {
        return Object.values(quantity).find(qty => qty > 0);
    }, [quantity])


    return <div className={classes.mainContainer}>
        <AppBar onCancel={() => changeMenu('main')}/>

        <Container maxWidth={'sm'}>
            <h2><Trans>Select quantity</Trans></h2>
            {product.subproducts.length > 0 && <SubProductList product={product}
                                                               handleChange={handleChange}
                                                               handleBlur={handleBlur}
                                                               increaseQuantity={increaseQuantity}
                                                               decreaseQuantity={decreaseQuantity}
                                                               quantity={quantity}
                                                                       hasCampaignPrice={hasCampaignPrice}
                                                               calculateSubProductPrice={calculateSubProductPrice}
            />}
            {product.subproducts.length == 0 && <BuyProduct product={product}
                                                            hasCampaignPrice={hasCampaignPrice}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            increaseQuantity={increaseQuantity}
                                                            decreaseQuantity={decreaseQuantity}
                                                            quantity={quantity}
                                                            calculateSubProductPrice={calculateSubProductPrice}
            />}
            <div className={classes.totalSummary}>
                <div className={classes.totalQuantityContainer}>
                    {t("%d pcs", {postProcess: 'sprintf', sprintf: [totalQuantity]})}
                </div>
                <div className={classes.totalPriceContainer}>
                    {t("Sum %s", {postProcess: 'sprintf', sprintf: [formatCurrency(totalPrice)]})}
                </div>
            </div>
        </Container>

        <div className={classes.buttonContainer}>
            <LoadingButton isLoading={isUpdating} variant='contained' color="primary"
                    disabled={!cartIsEnabled}
                    onClick={handleAddToCart}><Trans>Add to cart</Trans></LoadingButton>
        </div>
    </div>
}

const SubProductList = ({product, quantity, ...rest}) => {
    const classes = useStyles();

    return <div>
        <ul className={classes.subProductList}>
        {product.subproducts.map((subproduct) => {
            return <OrderSubProductItem key={subproduct.uuid} uuid={subproduct.uuid} subproduct={subproduct}
                                        productName={`${product.name} ${subproduct.name}`} product={product}
                                        quantity={quantity} {...rest}/>
        })}
    </ul>
    </div>
}


const BuyProduct = ({product, quantity, ...rest}) => {
    const classes = useStyles();

    return <div>
        <ul className={classes.subProductList}>
            <OrderSubProductItem uuid='' productName={product.name} product={product} quantity={quantity} {...rest}/>
        </ul>
    </div>
}

const OrderSubProductItem = ({
                                 productName,
                                 product,
                                 subproduct,
                                 uuid,
                                 hasCampaignPrice,
                                 handleChange,
                                 quantity,
                                 handleBlur,
                                 increaseQuantity,
                                 decreaseQuantity
                             }) => {
    const classes = useStyles();
    const { getPricePerUnit, calculateLinePrice  } = usePriceList();
    const { t } = useTranslation();

    const calculateSubProductPrice = (product, subproduct, quantity, hasCampaignPrice) => {
        if (!quantity) {
            quantity = 1;
        }
        let price = getPricePerUnit(product, quantity, hasCampaignPrice);
        if (subproduct) {
            price += subproduct.extraprice;
        }
        return price;
    }

    const ppu = calculateSubProductPrice(product, subproduct, parseInt(quantity[uuid]));
    const cppu = calculateSubProductPrice(product, subproduct, parseInt(quantity[uuid]), hasCampaignPrice);

    return <li>
        <div className={classes.productRow}>
            <button className={classes.iconButton} onClick={decreaseQuantity(uuid)}>
                <Icon>remove</Icon>
            </button>
            <input type='text' className={classes.quantity}
                   value={typeof (quantity[uuid]) == 'undefined' ? 0 : quantity[uuid]}
                   onChange={handleChange(uuid)}
                   onBlur={handleBlur(uuid)}/>
            <button className={classes.iconButton} onClick={increaseQuantity(uuid)}>
                <Icon>add</Icon>
            </button>

            <div className={classes.productName}>
                {productName}
                <div className={classes.productPriceContainer}>
                    {hasCampaignPrice &&
                        <div>{t("%s/pcs", {postProcess: 'sprintf', sprintf: [formatCurrency(cppu)]})}</div>}
                    <div className={`${classes.productPrice} ${hasCampaignPrice ? classes.oldPrice : ''}`}>
                        {t("%s/pcs", {postProcess: 'sprintf', sprintf: [formatCurrency(ppu)]})}
                    </div>
                </div>
            </div>
        </div>
    </li>
}